/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';

// Components
import {
  StatusIndicatorStatus,
} from '../../../../../../layout/elements/StatusIndicator';

/** Reusable styles */
const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.lidStatusDrawer.borderColor;

export const LidStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  margin-bottom: 20px;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    flex-direction: row;
  };
`;

export const LidStatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const LastOpenedOnContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-top: 1px solid ${borderColor};
  flex: 1;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0.75rem 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-top: none;
    border-left: 1px solid ${borderColor};
  };
`;

export const LastOpenedOnTime = styled.span`
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.crusherDashboard.detailsModule.lastUpdateTimeTextColor};
`;

export const LidPermissivesTitle = styled.div`
  margin-top: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: 1px solid ${borderColor};
  padding: 0.75rem 1rem;
  border-radius: 4px 4px 0px 0px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 1.5rem;
  };
`;

export const LidStatusPermissivesContainer = styled.div`
  width: 100%;
  flex-direction: column;
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  border-radius: 0px 0px 4px 4px;
`;

export const FirstPermissivesListContainer = styled.div`
  padding: 0rem 1rem 0rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0rem 1.25rem 0rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 0rem 1.25rem 1.25rem 1.5rem;
  };
`;

export const PermissivesListContainer = styled.div`
  padding: 0rem 1rem 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0rem 1.25rem 1.25rem 1.5rem;
  };
`;

export const PermissiveItem = styled.li<{ status: StatusIndicatorStatus }>`
  list-style-type: none;
  margin: 0;
  padding: 0.75rem 1.25rem 0.75rem 0.875rem;
  background-color: ${({ status, theme }) => (
    status === StatusIndicatorStatus.alarm
      ? theme.color.crusherDashboard.lidStatusDrawer.descriptionListErrorBackgroundColor
      : 'transparent'
  )};
  border-radius: 4px;
`;

export const PermissiveTitleContainer = styled.div`
  padding: 0.75rem 1rem 0.625rem 1rem;
  border-right: 1px solid ${borderColor};
  border-left: 1px solid ${borderColor};
  width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.1875rem 1.5rem 0.625rem 1.625rem;
  };
`;

export const LidStatusTableContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid ${borderColor};
  border-radius: 4px;

  > p {
    margin-bottom: 16px;
  }
`;
